module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      },
      "right-options": {
        showMore: true
      }
    }
  }, [_vm._v("\n\t\t\t注册\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "register-container"
  }, [_c('div', {
    staticClass: "sign-form"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telNum),
      expression: "telNum"
    }],
    attrs: {
      "type": "text",
      "placeholder": "手机号",
      "regtext": "请输入手机号"
    },
    domProps: {
      "value": (_vm.telNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telNum = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Mbcode),
      expression: "Mbcode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "验证码",
      "maxlength": "6",
      "regtext": "请输入验证码"
    },
    domProps: {
      "value": (_vm.Mbcode)
    },
    on: {
      "blur": _vm.loseB,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Mbcode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "get-code",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showFlag
    }
  }, [_vm._v("获取验证码")])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [(!_vm.passShow) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.psd),
      expression: "psd"
    }],
    attrs: {
      "type": "password",
      "placeholder": "密码",
      "regtext": "请输入密码"
    },
    domProps: {
      "value": (_vm.psd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.psd = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passShow) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.psd),
      expression: "psd"
    }],
    attrs: {
      "type": "text",
      "placeholder": "密码",
      "regtext": "请输入密码"
    },
    domProps: {
      "value": (_vm.psd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.psd = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "pass-display pass-show",
    class: {
      'pass-show': !_vm.passShow, 'pass-hide': _vm.passShow
    },
    on: {
      "click": _vm.changePassDisplay
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [(!_vm.passShow1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkPsd),
      expression: "checkPsd"
    }],
    attrs: {
      "type": "password",
      "placeholder": "确认密码",
      "regtext": "请输入确认密码"
    },
    domProps: {
      "value": (_vm.checkPsd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkPsd = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passShow1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkPsd),
      expression: "checkPsd"
    }],
    attrs: {
      "type": "text",
      "placeholder": "确认密码",
      "regtext": "请输入确认密码"
    },
    domProps: {
      "value": (_vm.checkPsd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkPsd = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "pass-display pass-show",
    class: {
      'pass-show': !_vm.passShow1, 'pass-hide': _vm.passShow1
    },
    on: {
      "click": _vm.changePassDisplay1
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.qqNum),
      expression: "qqNum"
    }],
    attrs: {
      "type": "text",
      "placeholder": "QQ号码",
      "regtext": "请输入QQ号码"
    },
    domProps: {
      "value": (_vm.qqNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.qqNum = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "同意协议并提交"
    },
    on: {
      "click": _vm.register
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-item register-pact"
  }, [_c('router-link', {
    attrs: {
      "to": "/agreement"
    }
  }, [_vm._v("《阿贝云网站服务协议》")])], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('alert', {
    attrs: {
      "title": _vm.alertShow
    },
    on: {
      "on-show": _vm.onShow,
      "on-hide": _vm.onHide
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "input_left",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img_right",
    attrs: {
      "src": this.codeSrc
    },
    on: {
      "click": this.getCode
    }
  })])])], 1), _vm._v(" "), _c('toast', {
    staticClass: "zjwToast",
    attrs: {
      "type": _vm.tipType,
      "width": "4.5rem",
      "text": _vm.tiptxt,
      "time": 1800,
      "is-show-mask": "",
      "position": _vm.position
    },
    model: {
      value: (_vm.showPositionValue),
      callback: function($$v) {
        _vm.showPositionValue = $$v
      },
      expression: "showPositionValue"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "register-gift"
  }, [_c('span', [_vm._v("注册领176元新手大礼包")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50696483","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/register.vue
// module id = Ulir
// module chunks = 1